import React from 'react'
import Navbar from './components/Navbar'
import HeroSection from "./components/HeroSection"
import Footer from './components/Footer'
import AboutSection from './components/AboutSection'
import PortfolioSection from './components/PortfolioSection'
import ResumeLink from './ResumeLink'
import EducationalDetail from './components/EducationalDetail'

export default function App() {
  return (
    <div>
        <Navbar/>
        <HeroSection/>
        <AboutSection/>
        <PortfolioSection/>
        <ResumeLink/>
        <EducationalDetail/>
        <Footer/>
    </div>
  )
}